import { render, staticRenderFns } from "./CloningForm.vue?vue&type=template&id=500008c0&scoped=true"
import script from "./CloningForm.vue?vue&type=script&lang=js"
export * from "./CloningForm.vue?vue&type=script&lang=js"
import style0 from "./CloningForm.vue?vue&type=style&index=0&id=500008c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500008c0",
  null
  
)

export default component.exports